import React from "react";
import "../styles/Footer.scss";
import { FaChevronUp } from 'react-icons/fa';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-bottom">
        <div>
          Copyright 2025 <span>GETAM</span>. All rights reserved -
          Design by <span>GETAM</span> |
          <a href="/impressum" style={{ marginLeft: '10px', color: 'inherit', textDecoration: 'none' }}>Impressum</a> |
          <a href="/privacy-policy" style={{ marginLeft: '10px', color: 'inherit', textDecoration: 'none' }}>Privacy Policy</a>
        </div>

        <div className="social-icons">
          <a
            href="https://www.instagram.com/getamcineworld/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Instagram"
          >
            <i className="fab fa-instagram"></i>
          </a>

          <a
            href="https://www.facebook.com/getamcinema/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Facebook"
          >
            <i className="fab fa-facebook-f"></i>
          </a>

          <a
            href="https://x.com/getamcineworld?lang=en"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="X (Twitter)"
          >
            <i className="fab fa-x-twitter"></i>
          </a>
        </div>
      </div>

      <div className="scroll-top" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
        <FaChevronUp />
      </div>
    </footer>
  );
};

export default Footer;
